import React, { useEffect, useState } from "react"
import styled from "@emotion/styled";
import SaveIcon from '@mui/icons-material/Save';
import CircularProgress from "@mui/material/CircularProgress";
import AssigneeDropdown from "../../../../DropDowns/AssigneeDropdown"
import { useAddLeadAssigneesMutation, useUpdateMortgageAssigneesMutation } from "../../../../../slices/api/apiSlice"
import { Button, InputWrapper } from "../../../../../StyledComponents"

const AddAssigneesInput = ({ activeLead, userId, teamMembersByName, currentAssigneeIds, leadData, userFullName, addAssigneesPerm, mortgageId, entity, setIsError, setIsSuccess, isSuccess }) => {

  const [isFetching, setIsFetching] = useState(false)
  const [statusLeadEmpty, setStatusLeadEmpty] = useState(false)
  const [saveLeadAllowed, setSaveLeadAllowed] = useState(false)

  const [newAssigneeIds, setNewAssigneeIds] = useState([])
  const [removedAssigneeIds, setRemovedAssigneeIds] = useState([])
  const [updatedAssigneeIds, setUpdatedAssigneeIds] = useState([])
  const [previousAssigneeNames, setPreviousAssigneeNames] = useState([])

  const[addLeadAssignees] = useAddLeadAssigneesMutation()
  const[updateMortgageAssignees] = useUpdateMortgageAssigneesMutation()

  const handleSetLeadAssignee = (event) => {
    let newAssigneeIds = []
    let removedAssigneeIds = []
    let updatedAssigneeIds = event.target.value
    let previousAssigneeIds = []
    for (let i = 0; i < updatedAssigneeIds.length; i++) {
      let existing = currentAssigneeIds.find(id => id === updatedAssigneeIds[i])
      if (existing) {
        previousAssigneeIds.push(existing)
      } else {
        newAssigneeIds.push(updatedAssigneeIds[i])
      }
    }
    if (previousAssigneeIds.length < currentAssigneeIds.length) {
      for (let i = 0; i < currentAssigneeIds.length; i++) {
        let matching = previousAssigneeIds.find(id => id === currentAssigneeIds[i])
        if (!matching) {
          removedAssigneeIds.push(currentAssigneeIds[i])
        }
      }
    }
    if (newAssigneeIds.length === 0 && removedAssigneeIds.length === 0) {
      setSaveLeadAllowed(false)
    } else {
      setSaveLeadAllowed(true)
    }
    setNewAssigneeIds(newAssigneeIds)
    setRemovedAssigneeIds(removedAssigneeIds)
    setUpdatedAssigneeIds(updatedAssigneeIds)
    if (isSuccess) {
      setIsSuccess(false)
    }
    if (statusLeadEmpty) {
      setStatusLeadEmpty(false)
    }
  }

  const handleUpdateMortgageAssignees = async () => {
    setIsError(false)
    setIsSuccess(false)
    setIsFetching(true)
    let leadId = null
    if (leadData) {
      leadId = leadData._id
    }
    let reqObj = {
      mortgageId: mortgageId,
      userId: userId,
      leadId: leadId,
      userFullName: userFullName,
      newAssigneeNames: [],
      newAssigneeIds: newAssigneeIds,
      updatedAssigneeNames: [],
      updatedAssigneeIds: updatedAssigneeIds,
      removedAssigneeNames: [],
      removedAssigneeIds: removedAssigneeIds,
      previousAssigneeNames: [],
    }
    if (newAssigneeIds.length > 0) {
      for (let i = 0; i < newAssigneeIds.length; i++) {
        let matching = teamMembersByName.find(assignee => assignee.memberId === newAssigneeIds[i])
        if (matching) {
          reqObj.newAssigneeNames.push(matching.fullName)
        }
      }
    }
    if (removedAssigneeIds.length > 0) {
      for (let i = 0; i < removedAssigneeIds.length; i++) {
        let matching = teamMembersByName.find(assignee => assignee.memberId === removedAssigneeIds[i])
        if (matching) {
          reqObj.removedAssigneeNames.push(matching.fullName)
        }
      }
    }
    if (currentAssigneeIds.length > 0) {
      for (let i = 0; i < currentAssigneeIds.length; i++) {
        let matching = teamMembersByName.find(assignee => assignee.memberId === currentAssigneeIds[i])
        if (matching) {
          reqObj.previousAssigneeNames.push(matching.fullName)
        }
      }
    }
    if (updatedAssigneeIds.length > 0) {
      for (let i = 0; i < updatedAssigneeIds.length; i++) {
        let matching = teamMembersByName.find(assignee => assignee.memberId === updatedAssigneeIds[i])
        if (matching) {
          reqObj.updatedAssigneeNames.push(matching.fullName)
        }
      }
    }
    let resp = {}
    if (entity === 'mortgage') {
      resp = await updateMortgageAssignees(reqObj)
    } else {
      resp = await addLeadAssignees(reqObj)
    }
    if (resp.error) {
      setIsError(true)
    }
    setNewAssigneeIds([])
    setRemovedAssigneeIds([])
    setIsFetching(false)
  }

  useEffect(() => {
    let assigneeNames = []
    if (activeLead) {
      for (let i = 0; i < currentAssigneeIds.length; i++) {
        let assignee = teamMembersByName.find(assignee => assignee.memberId.toString() === currentAssigneeIds[i].toString())
        assigneeNames.push(assignee.fullName)
      }
    }
    setSaveLeadAllowed(false)
    setUpdatedAssigneeIds(currentAssigneeIds)
    setPreviousAssigneeNames(assigneeNames)
}, [activeLead, teamMembersByName, currentAssigneeIds])

  return (
    <AssignmentWorkspace>
      <CurrentAssigneesCard>
        <SectionHeader>
          <SectionTitle>
            Current {entity === 'mortgage' ? 'Mortgage' : 'Investigation'} Assignees
          </SectionTitle>
          <CountBadge>{previousAssigneeNames.length}</CountBadge>
        </SectionHeader>
        {previousAssigneeNames.length > 0 ?
          <AssigneeList>
          {previousAssigneeNames.map((assignee) => (
            <AssigneeChip key={assignee}>
              <AvatarMark>{assignee.slice(0, 1)}</AvatarMark>
              <span>{assignee}</span>
            </AssigneeChip>
          ))}
          </AssigneeList>
        :
          <EmptyState>
            There is currently no one assigned to the {entity === 'mortgage' ? 'mortgage' : 'investigation'}.
          </EmptyState>
        }
      </CurrentAssigneesCard>

      <AssignmentCard>
        <AssignmentField>
          <FieldHeader>
            <FieldTitle>Assign to {entity === 'mortgage' ? 'Mortgage' : 'Investigation'}</FieldTitle>
            {!addAssigneesPerm &&
              <PermissionText>Permission required</PermissionText>
            }
          </FieldHeader>
          <AssigneeDropdown
            value={updatedAssigneeIds}
            handleChange={handleSetLeadAssignee}
            items={teamMembersByName}
            disabled={!addAssigneesPerm}
          />
        </AssignmentField>
        <Button
          onClick={(saveLeadAllowed && addAssigneesPerm) ? () => handleUpdateMortgageAssignees() : null}
          className={(!saveLeadAllowed || !addAssigneesPerm) ? "primaryDisabled notes" : isFetching ? "primaryLoading notes" : "primary notes"}
        >
          {isFetching ?
            <CircularProgress size={18} />
          :
            <SaveIcon />
          }
        </Button>
      </AssignmentCard>
    </AssignmentWorkspace>
  )
}

const AssignmentWorkspace = styled.div`
  min-width: 0;
  display: grid;
  gap: 1rem;
`

const CurrentAssigneesCard = styled.section(({ theme }) => `
  min-width: 0;
  display: grid;
  gap: 0.85rem;
  padding: 1rem;
  border: 0.1rem solid ${theme.palette.common.grayBorder};
  border-radius: 0.8rem;
  background: ${theme.palette.common.white};
`)

const SectionHeader = styled.div(({ theme }) => `
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  padding-bottom: 0.75rem;
  border-bottom: 0.1rem solid ${theme.palette.common.grayBorder};
`)

const SectionTitle = styled.div(({ theme }) => `
  color: ${theme.palette.common.black};
  font-size: 1rem;
  font-weight: 800;
`)

const CountBadge = styled.div(({ theme }) => `
  min-width: 2rem;
  height: 2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 999rem;
  background: ${theme.palette.primary.labelTransparent};
  color: ${theme.palette.primary.dark};
  font-size: 0.85rem;
  font-weight: 800;
`)

const AssigneeList = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.65rem;
`

const AssigneeChip = styled.div(({ theme }) => `
  min-height: 2.5rem;
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.4rem 0.75rem 0.4rem 0.45rem;
  border: 0.1rem solid ${theme.palette.common.grayBorder};
  border-radius: 999rem;
  background: ${theme.palette.common.cardBackground};
  color: ${theme.palette.common.black};
  font-size: 0.9rem;
  font-weight: 800;
`)

const AvatarMark = styled.span(({ theme }) => `
  width: 1.6rem;
  height: 1.6rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 999rem;
  background: ${theme.palette.primary.dark};
  color: ${theme.palette.common.white};
  font-size: 0.8rem;
  font-weight: 800;
  text-transform: uppercase;
`)

const EmptyState = styled.div(({ theme }) => `
  padding: 1.5rem;
  border: 0.1rem dashed ${theme.palette.common.grayBorderDark};
  border-radius: 0.8rem;
  background: ${theme.palette.common.cardBackground};
  color: ${theme.palette.common.grayText};
  text-align: center;
  font-size: 0.95rem;
  font-weight: 700;
`)

const AssignmentCard = styled.section(({ theme }) => `
  min-width: 0;
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  gap: 0.75rem;
  align-items: end;
  padding: 1rem;
  border: 0.1rem solid ${theme.palette.common.grayBorder};
  border-radius: 0.8rem;
  background: ${theme.palette.common.white};
`)

const AssignmentField = styled(InputWrapper)`
  width: 100%;
  min-width: 0;
  margin: 0;
  align-items: stretch;
`

const FieldHeader = styled.div`
  min-height: 2rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
`

const FieldTitle = styled.div(({ theme }) => `
  color: ${theme.palette.common.black};
  font-size: 0.9rem;
  font-weight: 800;
`)

const PermissionText = styled.div(({ theme }) => `
  color: ${theme.palette.common.grayText};
  font-size: 0.8rem;
  font-weight: 800;
  text-transform: uppercase;
`)

export default AddAssigneesInput
